import { css } from "@emotion/react"

export const tradeOpenInputCss = css({
  padding: "0 8px",
  margin: "8px 0 16px 0",
})
